import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import ar from './locales/ar.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import es from './locales/es.json';

export const APP_DIRECTION = {
    ltr: 'ltr',
    rtl: 'rtl',
};

export const APP_LANGUAGES = {
    EN: 'en',
    AR: 'ar',
    FR: 'fr',
    DE: 'de',
    ES: 'es',
};

// Get saved language from localStorage or default to English
const savedLanguage = localStorage.getItem('appLanguage') || APP_LANGUAGES.EN;

i18n
    .use(initReactI18next)
    .init({
        compatibilityJSON: 'v3',
        resources: {
            en: { translation: en },
            ar: { translation: ar },
            fr: { translation: fr },
            de: { translation: de },
            es: { translation: es },
        },
        lng: savedLanguage,
        fallbackLng: APP_LANGUAGES.EN,
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
        },
    });

// Save language changes to localStorage
i18n.on('languageChanged', (lng) => {
    localStorage.setItem('appLanguage', lng);
    // Update document direction for RTL languages
    document.documentElement.dir = lng === APP_LANGUAGES.AR ? APP_DIRECTION.rtl : APP_DIRECTION.ltr;
    document.documentElement.lang = lng;
});

// Set initial direction
document.documentElement.dir = savedLanguage === APP_LANGUAGES.AR ? APP_DIRECTION.rtl : APP_DIRECTION.ltr;
document.documentElement.lang = savedLanguage;

export default i18n;